const en = {};

export default en;
export const enValidation = {
    name: 'en',
    messages: {
        '_default': (e: any) => {
            return `The value of field ${e} is not valid.`;
        },
        'after': (e: any, n: any) => {
            return `The ${e} must be after ${n[0]}.`;
        },
        'alpha': (e: any) => {
            return `The ${e} field can only contain alphabetic characters.`;
        },
        'alpha_dash': (e: any) => {
            return `The ${e} field can contain alphanumeric characters as well as dashes and underscores.`;
        },
        'alpha_num': (e: any) => {
            return `The ${e} field can only contain alphanumeric characters`;
        },
        'alpha_spaces': (e: any) => {
            return `The ${e} field can only contain alphanumeric characters as well as spaces.`;
        },
        'before': (e: any, n: any) => {
            return `The field ${e} must be before ${n[0]}.`;
        },
        'between': (e: any, n: any) => {
            return `The field ${e} must be between ${n[0]} and ${n[1]}`;
        },
        'confirmed': (e: any, n: any) => {
            return `Field ${e} does not match ${n[0]}.`;
        },
        'credit_card': (e: any) => {
            return `The field ${e} is invalid.`;
        },
        'date_between': (e: any, n: any) => {
            return `The ${e} must be between ${n[0]} and ${n[1]}.`;
        },
        'date_format': (e: any, n: any) => {
            return `The ${e} must be in the format ${n[0]}.`;
        },
        'decimal': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-void, no-param-reassign
            void 0 === n && (n = []);
            let r = n[0];
            // eslint-disable-next-line no-return-assign
            return (
                // eslint-disable-next-line no-void
                void 0 === r && (r = '*'),
                `The field ${e} must be numeric and can contain ${r && r !== '*' ? ` ${r}` : ''} decimal points.`
            );
        },
        'digits': (e: any, n: any) => {
            return `The ${e} field must be numeric and contain exactly ${n[0]} digits.`;
        },
        'dimensions': (e: any, n: any) => {
            return `The field ${e} must be ${n[0]} x ${n[1]}.`;
        },
        'email': (e: any) => {
            return `The ${e} field must be a valid email address.`;
        },
        'excluded': (e: any) => {
            return `The field ${e} must have a valid value.`;
        },
        'ext': (e: any) => {
            return `The ${e} field must be a valid file.`;
        },
        'image': (e: any) => {
            return `The ${e} field must be an image.`;
        },
        'included': (e: any) => {
            return `The field ${e} must have a valid value.`;
        },
        'ip': (e: any) => {
            return `The ${e} field must be a valid IP address.`;
        },
        'length': (e: any, n: any) => {
            const r = n[0];
            const o = n[1];
            return o
                ? `The length of the field ${e} must be between ${r} and ${o}.`
                : `The length of the field ${e} must be ${r}.`;
        },
        'max': (e: any, n: any) => {
            return `The field ${e} cannot be longer than ${n[0]} characters.`;
        },
        'c': (e: any, n: any) => {
            return `The field ${e} must be less than or equal to ${n[0]}`;
        },
        'mimes': (e: any) => {
            return `The ${e} field must have a valid file type.`;
        },
        'min': (e: any, n: any) => {
            return `The field ${e} must have at least ${n[0]} characters.`;
        },
        'min_value': (e: any, n: any) => {
            return `The field ${e} must be greater than or equal to ${n[0]}`;
        },
        'numeric': (e: any) => {
            return `The ${e} field can only contain numeric characters.`;
        },
        'regex': (e: any) => {
            return `Attention the field ${e} does not have a valid format.`;
        },
        'required': (e: any) => {
            return `The field ${e} is required.`;
        },
        'size': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            return `The field ${e} must be less than ${((e) => {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const n = 1024;
                // eslint-disable-next-line no-cond-assign, no-param-reassign
                const r = (e = Number(e) * n) === 0 ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / n ** r).toFixed(2));
                const v = 1 * f;
                return `${v.toFixed(2)} ${['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][r]}`;
            })(n[0])}.`;
        },
        'url': (e: any) => {
            return `The ${e} field is not a valid URL.`;
        },
        'validate-piva-cf': () => {
            return 'Invalid VAT number / Tax code.';
        },
        'validate-regionid': () => {
            return 'The Province field is required.';
        },
        'validate-password-wf': () => {
            return 'The minimum length of this field must be equal to or greater than {1} characters. Leading and trailing spaces will be ignored. Verify that there are at least 2 of the following 3 conditions: at least one capital letter, at least one number, at least one special character.';
        },
        'validate-password-wf-length': () => {
            return 'The minimum length of this field must be equal to or greater than {1} characters. Leading and trailing spaces will be ignored.';
        },
        'validate-password-wf-character': () => {
            return 'Verify that there are at least 2 of the following 3 conditions: at least one capital letter, at least one number, at least one special character.';
        },
        'validate-length': (e: any) => {
            return `Attention the field ${e} must have a length of {1} characters.`;
        },
        'validate-fiscal-code': () => {
            return 'The fiscal code must be exactly %1 characters long.';
        },
        'validate-telephone-without-prefix': () => {
            return 'Please specify a valid phone number, must not contain the prefix (e.g. +44).';
        },
        'validate-foreign-country-telephone-without-prefix': () => {
            return 'Please specify a valid phone number, must not contain the prefix (e.g. +44).';
        },
    },
    attributes: {},
};
